module.exports = __webpack_public_path__ + "c70ea64d9511d641b79e8c8a7b55d148.pdf";